<template>
    <div class="">
        <div class="container">
            <div v-if="checkingDetails || loadingSavedData">
                <div class="spacer s30"></div>
                <h3>
                    <span class="loading-spinner"><font-awesome-icon icon="spinner" class="fa-spin 3x" /></span>&nbsp; {{ status }}
                </h3>
            </div>

            <!-- <pre>{{ contents }}</pre> -->

            <!-- {{ formMeta }} -->
            <!-- <pre v-if="formMeta.sharedContent">{{ formMeta.sharedContent.map((m) => m.label) }}</pre> -->

            <div class="spacer s30 desktop"></div>
            <div v-if="reviewMode" class="alert-bar">
                <div v-if="userProfile.currentReviewDocID != ''"><font-awesome-icon icon="check" /> &nbsp;</div>
                <div>
                    <font-awesome-icon icon="pen" /> &nbsp;
                    <span>Audit mode active</span>
                </div>
                <div class="buttons">
                    <span class="button is-small is-info" @click="setupGeneralNotes()">General Notes</span>
                    <span class="button is-small is-primary" @click="previewFinalSave()">Complete Audit</span>
                </div>
            </div>

            <!-- <pre>XX: {{ userProfile }}</pre> -->

            <!-- <pre class="mt-6">{{ finalReviewMap }}</pre> -->
            <!-- <pre>{{ formMeta }}</pre> -->

            <div v-if="formLoaded" class="columns" :class="{ padded: reviewMode }">
                <div v-if="accessAllowed" class="column">
                    <div class="flex">
                        <div
                            class="asset-avatar"
                            v-if="vesselData.avatarUrl && vesselData.avatarUrl != ''"
                            :style="{ backgroundImage: `url(${vesselData.avatarUrl})` }"
                            @click="openImageModal(vesselData.avatarUrl)"></div>
                        <div class="top-content">
                            <h3>Safety Management System for {{ currentVesselName }}</h3>

                            <div class="red-heading" v-if="formMeta.isImmutable">
                                <span>Snapshot Timestamp: {{ simpleDate(toDate(formMeta.timestamp), true, true) }}</span>
                            </div>
                            <div v-else>
                                <h5 class="mt-2">Current Timestamp: {{ simpleDate(new Date(), true, true) }}</h5>
                            </div>

                            <div v-if="formMeta.hasExpiryDate">
                                <div v-if="formMeta.isCurrent" class="date green bold">
                                    Valid for {{ timeLeft(toDate(formMeta.expiryDate)) }}
                                    {{ timeLeft(toDate(formMeta.expiryDate)) == 1 ? 'day' : 'days' }}
                                </div>
                                <div v-else class="red bold">Expired</div>
                            </div>
                        </div>
                    </div>

                    <div class="spacer s30"></div>
                    <div class="sms-content">
                        <div class="sms-section box" v-for="(section, idx) in sorted(displaySections)" :key="`section-${idx}`">
                            <!-- text/para content ================================= -->
                            <div v-if="section.type == 'para'">
                                <a :id="'section-' + section.index" class="anchor"></a>
                                <h4 style="color: cadetblue; text-transform: uppercase; font-weight: bold; font-size: 1.1rem; margin-bottom: 8px">
                                    <font-awesome-icon :icon="section.icon" /> &nbsp; {{ section.title }}
                                </h4>
                                <div>
                                    <p v-for="(line, icx) in section.content.split('\n')" :key="`line-1-${icx}`">{{ line }}</p>
                                </div>
                                <span
                                    v-if="reviewMode"
                                    class="button is-small"
                                    :class="[
                                        finalReviewMap[section.reviewSlug]?.notes && finalReviewMap[section.reviewSlug]?.notes.length > 0
                                            ? 'is-primary'
                                            : 'is-light'
                                    ]"
                                    @click="addAuditNote(true, section.reviewSlug, section)">
                                    <font-awesome-icon icon="pen" /> &nbsp; Add Audit Notes
                                </span>
                            </div>

                            <!-- photo content ================================= -->
                            <!-- <div v-if="section.type == 'photo'">
                                <a :id="'section-' + section.index" class="anchor"></a>
                                <h4
                                    style="color: cadetblue; text-transform: uppercase; font-weight: bold; font-size: 1.1rem; margin-bottom: 8px"
                                    class="hideForPrint">
                                    <font-awesome-icon :icon="section.icon" /> &nbsp; {{ section.title }}
                                </h4>
                                <div class="main-image">
                                    <img :src="section.content" />
                                </div>
                            </div> -->

                            <!-- 2 column table content ================================= -->
                            <div v-if="section.type == 'table'">
                                <a :id="'section-' + section.index" class="anchor"></a>
                                <h4 style="color: cadetblue; text-transform: uppercase; font-weight: bold; font-size: 1.1rem; margin-bottom: 8px">
                                    <font-awesome-icon :icon="section.icon" /> &nbsp; {{ section.title }}
                                </h4>
                                <table style="border-spacing: 0 !important; table-layout: fixed" class="table is-fullwidth set-col">
                                    <tr
                                        v-for="(row, irx) in section.content"
                                        :key="`row-1-${irx}`"
                                        :class="{ hidden: !row.content || row.content == '' }">
                                        <td
                                            style="
                                                width: 30% !important;
                                                max-width: 280px !important;
                                                border-bottom: 1px solid #e1e1e1 !important;
                                                padding: 10px !important;
                                            ">
                                            {{ row.header }}
                                        </td>
                                        <td style="width: 70% !important; border-bottom: 1px solid #e1e1e1 !important; padding: 10px !important">
                                            <div v-if="row.content">
                                                <div v-if="row.content.length > 0 && row.content.split('\n') != undefined">
                                                    <p v-for="(line, idx) in row.content.split('\n')" :key="`line-2-${idx}`">{{ line }}</p>
                                                </div>
                                                <div v-else>
                                                    {{ row.content }}
                                                </div>
                                            </div>
                                        </td>
                                    </tr>
                                    <tr v-if="reviewMode">
                                        <td colspan="2" class="is-last">
                                            <div class="buttons right">
                                                <span
                                                    class="button is-small"
                                                    :class="[
                                                        finalReviewMap[section.reviewSlug]?.notes &&
                                                        finalReviewMap[section.reviewSlug]?.notes.length > 0
                                                            ? 'is-primary'
                                                            : 'is-light'
                                                    ]"
                                                    @click="addAuditNote(true, section.reviewSlug, section)">
                                                    <font-awesome-icon icon="pen" /> &nbsp; Add Audit Notes
                                                </span>
                                            </div>
                                        </td>
                                    </tr>
                                </table>
                            </div>

                            <!-- single column table content ================================= -->
                            <div v-if="section.type == 'table-rows'">
                                <a :id="'section-' + section.index" class="anchor"></a>
                                <h4 style="color: cadetblue; text-transform: uppercase; font-weight: bold; font-size: 1.1rem; margin-bottom: 12px">
                                    <font-awesome-icon :icon="section.icon" /> &nbsp; {{ section.title }}
                                </h4>
                                <table
                                    style="border-spacing: 0 !important; table-layout: fixed"
                                    v-for="(row, irx) in section.content"
                                    :key="`row-2-${irx}`"
                                    class="table is-fullwidth single-col"
                                    :class="{ hidden: !row.content || row.content == '' }">
                                    <tr class="first" style="background: #f9f9f9 !important; padding: 8px 10px !important">
                                        <td style="padding: 10px !important">{{ row.header }}</td>
                                    </tr>
                                    <tr>
                                        <td style="padding: 10px !important">
                                            <div
                                                v-if="row.content"
                                                @click="
                                                    row.show = !row.show;
                                                    row.limit = row.show || showAllContent ? 10000 : 200;
                                                "
                                                class="toggle-content">
                                                <p v-for="(line, itx) in truncate(row.content, row.limit).split('\n')" :key="`line-4-${itx}`">
                                                    {{ line }}
                                                </p>
                                                <div class="toggler">Click to {{ !row.show ? 'Show' : 'Hide' }}</div>
                                            </div>
                                        </td>
                                    </tr>
                                    <tr v-if="reviewMode">
                                        <td colspan="2" class="is-last">
                                            <div class="buttons right">
                                                <span
                                                    class="button is-small"
                                                    :class="[
                                                        finalReviewMap[row.reviewSlug]?.notes && finalReviewMap[row.reviewSlug]?.notes.length > 0
                                                            ? 'is-primary'
                                                            : 'is-light'
                                                    ]"
                                                    @click="addAuditNote(true, row.reviewSlug ?? 'table-rows', row)">
                                                    <font-awesome-icon icon="pen" /> &nbsp; Add Audit Notes
                                                </span>
                                            </div>
                                        </td>
                                    </tr>
                                </table>
                            </div>

                            <!-- special roles and statements table content ================================= -->
                            <div v-if="section.type == 'table-statements'">
                                <a :id="'section-' + section.index" class="anchor"></a>
                                <h4 style="color: cadetblue; text-transform: uppercase; font-weight: bold; font-size: 1.1rem; margin-bottom: 12px">
                                    <font-awesome-icon :icon="section.icon" /> &nbsp; {{ section.title }}
                                </h4>
                                <div v-for="(row, irx) in section.content" :key="`row-3-${irx}`">
                                    <h5>{{ row.title }}</h5>
                                    <div v-if="row.statements.length > 0">
                                        <table
                                            style="border-spacing: 0 !important; table-layout: fixed"
                                            v-for="(cell, idx) in row.statements"
                                            :key="`cell-${irx}-${idx}`"
                                            class="table is-fullwidth single-col">
                                            <tr class="first" style="background: #f9f9f9 !important; padding: 8px 10px !important">
                                                <td style="padding: 10px !important">{{ cell.title }}</td>
                                            </tr>
                                            <tr>
                                                <td style="padding: 10px !important">
                                                    <div
                                                        v-if="cell.details"
                                                        @click="
                                                            cell.show = !cell.show;
                                                            cell.limit = cell.show || showAllContent ? 10000 : 200;
                                                        "
                                                        class="toggle-content">
                                                        <p
                                                            v-for="(line, itx) in truncate(cell.details, cell.limit).split('\n')"
                                                            :key="`line-4-${itx}`">
                                                            {{ line }}
                                                        </p>
                                                        <div class="toggler">Click to {{ !cell.show ? 'Show' : 'Hide' }}</div>
                                                    </div>
                                                </td>
                                            </tr>
                                        </table>
                                    </div>
                                    <div v-else>No role statement.</div>
                                </div>
                                <div v-if="reviewMode">
                                    <div class="buttons right">
                                        <span
                                            class="button is-small"
                                            :class="[
                                                finalReviewMap[section.reviewSlug]?.notes && finalReviewMap[section.reviewSlug]?.notes.length > 0
                                                    ? 'is-primary'
                                                    : 'is-light'
                                            ]"
                                            @click="addAuditNote(true, section.reviewSlug ?? 'table-statements', section)">
                                            <font-awesome-icon icon="pen" /> &nbsp; Add Audit Notes
                                        </span>
                                    </div>
                                </div>
                            </div>

                            <!-- plant & equipment content ================================= -->
                            <div v-if="section.type == 'plant'">
                                <a :id="'section-' + section.index" class="anchor"></a>
                                <h4 style="color: cadetblue; text-transform: uppercase; font-weight: bold; font-size: 1.1rem; margin-bottom: 8px">
                                    <font-awesome-icon :icon="section.icon" /> &nbsp; {{ section.title }}
                                </h4>
                                <div>
                                    <table
                                        style="border-spacing: 0 !important; table-layout: fixed"
                                        v-for="(row, idx) in sorted(section.content)"
                                        :key="`plant-1-${idx}`"
                                        class="table is-bordered is-fullwidth set-col">
                                        <tbody>
                                            <tr>
                                                <td
                                                    class="bold"
                                                    style="
                                                        width: 30% !important;
                                                        max-width: 280px !important;
                                                        border-bottom: 1px solid #e1e1e1 !important;
                                                        padding: 10px !important;
                                                    ">
                                                    P&E Item
                                                </td>
                                                <td
                                                    class="bold"
                                                    style="
                                                        width: 70% !important;
                                                        border-bottom: 1px solid #e1e1e1 !important;
                                                        padding: 10px !important;
                                                    ">
                                                    {{ row.header }}
                                                </td>
                                            </tr>
                                            <tr v-for="(sched, isx) in row.content.maintenanceSchedules" :key="`plant-2-${isx}`">
                                                <td
                                                    style="
                                                        width: 30% !important;
                                                        max-width: 280px !important;
                                                        border-bottom: 1px solid #e1e1e1 !important;
                                                        padding: 10px !important;
                                                    ">
                                                    {{ sched.title }}
                                                </td>
                                                <td
                                                    style="
                                                        width: 70% !important;
                                                        border-bottom: 1px solid #e1e1e1 !important;
                                                        padding: 10px !important;
                                                    ">
                                                    <div>
                                                        <font-awesome-icon icon="info-circle" />&nbsp; {{ sched.description ?? 'No description' }}
                                                    </div>
                                                    <div v-if="sched.trackTime">
                                                        <font-awesome-icon icon="stopwatch" />&nbsp; Repeats every {{ sched.frequencyNumber }}
                                                        {{ sched.frequencyPeriod }}
                                                    </div>
                                                    <div v-if="sched.trackTime">
                                                        <font-awesome-icon icon="calendar-check" />&nbsp; Next schedule:
                                                        {{ simpleDate(sched.dueDate, false, false) }}
                                                        <!-- {{ sched.dueDate }} -->
                                                    </div>
                                                    <div v-if="sched.trackHours">
                                                        <font-awesome-icon icon="stopwatch" />&nbsp; Repeats every {{ sched.frequency }} Hours
                                                    </div>
                                                    <div v-if="sched.trackHours">
                                                        <font-awesome-icon icon="wrench" />&nbsp; Next schedule: {{ sched.dueHours }} Hours
                                                    </div>
                                                </td>
                                            </tr>
                                            <tr v-if="reviewMode">
                                                <td colspan="2">
                                                    <div class="buttons right">
                                                        <span
                                                            class="button is-small"
                                                            :class="[
                                                                finalReviewMap[row.id]?.notes && finalReviewMap[row.id]?.notes.length > 0
                                                                    ? 'is-primary'
                                                                    : 'is-light'
                                                            ]"
                                                            @click="addAuditNote(false, 'plant', row)">
                                                            <font-awesome-icon icon="pen" /> &nbsp; Add Audit Notes
                                                        </span>
                                                    </div>
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>

                            <!-- drill content ================================= -->
                            <div v-if="section.type == 'drill'">
                                <a :id="'section-' + section.index" class="anchor"></a>
                                <h4 style="color: cadetblue; text-transform: uppercase; font-weight: bold; font-size: 1.1rem; margin-bottom: 8px">
                                    <font-awesome-icon :icon="section.icon" /> &nbsp; {{ section.title }}
                                </h4>
                                <div>
                                    <table
                                        style="border-spacing: 0 !important; table-layout: fixed !important"
                                        v-for="(row, idx) in sorted(section.content)"
                                        :key="`drill-1-${idx}`"
                                        class="table is-bordered is-fullwidth set-col">
                                        <tbody>
                                            <tr>
                                                <td
                                                    class="bold"
                                                    style="
                                                        width: 30% !important;
                                                        max-width: 280px !important;
                                                        border-bottom: 1px solid #e1e1e1 !important;
                                                        padding: 10px !important;
                                                    ">
                                                    Drill Title
                                                </td>
                                                <td
                                                    class="bold"
                                                    style="
                                                        width: 70% !important;
                                                        border-bottom: 1px solid #e1e1e1 !important;
                                                        padding: 10px !important;
                                                    ">
                                                    {{ row.header }}
                                                </td>
                                            </tr>
                                            <tr>
                                                <td
                                                    style="
                                                        width: 30% !important;
                                                        max-width: 280px !important;
                                                        border-bottom: 1px solid #e1e1e1 !important;
                                                        padding: 10px !important;
                                                    ">
                                                    Details
                                                </td>
                                                <td
                                                    style="
                                                        width: 70% !important;
                                                        border-bottom: 1px solid #e1e1e1 !important;
                                                        padding: 10px !important;
                                                    ">
                                                    <div v-if="row.content.description && row.content.description != ''">
                                                        <font-awesome-icon icon="info-circle" />&nbsp; {{ row.content.description }}
                                                    </div>
                                                    <div class="drill-freq">
                                                        <font-awesome-icon icon="stopwatch" />&nbsp; Repeats every {{ row.content.frequencyNumber }}
                                                        {{ row.content.frequencyPeriod }}
                                                    </div>
                                                    <div v-if="row.content.checklist">
                                                        <font-awesome-icon icon="list-ul" />&nbsp; Checklist
                                                        <ul class="listed">
                                                            <li v-for="(item, idx) in row.content.checklist" :key="`chk-${idx}`">{{ item }}</li>
                                                        </ul>
                                                    </div>
                                                    <div v-if="row.content.linkedSmsItems">
                                                        <div><font-awesome-icon icon="link" />&nbsp; Linked SMS Content:</div>
                                                        <div
                                                            class="linked-sms-items"
                                                            v-for="(bit, icx) in row.content.linkedSmsItems"
                                                            :key="`sms-item-${icx}`">
                                                            <div class="lsi-type">{{ bit.label }}</div>
                                                            <div class="lsi-title">{{ bit.title }}</div>
                                                        </div>
                                                    </div>
                                                </td>
                                            </tr>
                                            <tr v-if="reviewMode">
                                                <td colspan="2">
                                                    <div class="buttons right">
                                                        <span
                                                            class="button is-small"
                                                            :class="[
                                                                finalReviewMap[row.id]?.notes && finalReviewMap[row.id]?.notes.length > 0
                                                                    ? 'is-primary'
                                                                    : 'is-light'
                                                            ]"
                                                            @click="addAuditNote(false, 'drill', row)">
                                                            <font-awesome-icon icon="pen" /> &nbsp; Add Audit Notes
                                                        </span>
                                                    </div>
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>

                            <!-- hazards content ================================= -->
                            <div v-if="section.type == 'hazards'">
                                <a :id="'section-' + section.index" class="anchor"></a>
                                <h4 style="color: cadetblue; text-transform: uppercase; font-weight: bold; font-size: 1.1rem; margin-bottom: 8px">
                                    <font-awesome-icon :icon="section.icon" /> &nbsp; {{ section.title }}
                                </h4>

                                <div>
                                    <table
                                        style="border-spacing: 0 !important; table-layout: fixed"
                                        v-for="(hazard, idx) in sorted(section.content)"
                                        :key="`hazards-${idx}`"
                                        class="table is-bordered is-fullwidth set-col">
                                        <tbody>
                                            <tr>
                                                <td
                                                    class=""
                                                    style="
                                                        border-collapse: collapse;
                                                        width: 30% !important;
                                                        max-width: 280px !important;
                                                        border: 1px solid #e1e1e1 !important;
                                                        padding: 10px !important;
                                                    ">
                                                    <div class="">Title</div>
                                                    <div v-if="hazard.status == 'draft'" class="tag is-danger caps">DRAFT CONTENT</div>
                                                </td>
                                                <td
                                                    class="bold"
                                                    style="
                                                        width: 70% !important;
                                                        border-collapse: collapse;
                                                        border: 1px solid #e1e1e1 !important;
                                                        padding: 10px !important;
                                                    ">
                                                    {{ hazard.title }}
                                                </td>
                                            </tr>
                                            <tr>
                                                <td
                                                    style="
                                                        border-collapse: collapse;
                                                        width: 30% !important;
                                                        max-width: 280px !important;
                                                        border: 1px solid #e1e1e1 !important;
                                                        padding: 10px !important;
                                                    ">
                                                    Risks & Controls
                                                </td>
                                                <td
                                                    style="
                                                        width: 70% !important;
                                                        border-collapse: collapse;
                                                        border: 1px solid #e1e1e1 !important;
                                                        border-collapse: collapse !important;
                                                        padding: 10px !important;
                                                    ">
                                                    <div
                                                        v-if="hazard.riskPairs && hazard.riskPairs.length > 0"
                                                        class="toggle-content"
                                                        :class="{ show: hazard.show || showAllContent }"
                                                        @click="
                                                            hazard.show = !hazard.show;
                                                            hazard.limit = hazard.show || showAllContent ? 10000 : 200;
                                                        ">
                                                        <div v-for="(item, idx) in hazard.riskPairs" :key="`riskpair-${idx}`">
                                                            <div
                                                                class="risk-pair"
                                                                v-if="(item.risk && item.risk != '') || (item.control && item.control != '')">
                                                                <div v-if="item.risk">
                                                                    <p class="rp-title red">Risk / Hazard</p>
                                                                    <p
                                                                        class="rp-details"
                                                                        v-for="(line, irx) in truncate(item.risk, hazard.limit).split('\n')"
                                                                        :key="`line1-${irx}`">
                                                                        {{ line }}<br />
                                                                    </p>
                                                                </div>
                                                                <div v-if="item.control">
                                                                    <p class="rp-title green">Control</p>
                                                                    <p
                                                                        class="rp-details"
                                                                        v-for="(line, irx) in truncate(item.control, hazard.limit).split('\n')"
                                                                        :key="`line1-${irx}`">
                                                                        {{ line }}<br />
                                                                    </p>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div class="toggler">Click to {{ !hazard.show ? 'Show' : 'Hide' }}</div>
                                                    </div>
                                                    <div
                                                        v-if="hazard.riskPairs && hazard.riskPairs.length == 0"
                                                        class="toggle-content"
                                                        :class="{ show: hazard.show || showAllContent }"
                                                        @click="
                                                            hazard.show = !hazard.show;
                                                            hazard.limit = hazard.show || showAllContent ? 10000 : 200;
                                                        ">
                                                        <div v-if="hazard.risks && hazard.risks != ''" class="legacy-set">
                                                            <p class="bold red">Risks:</p>
                                                            <p
                                                                v-for="(line, itx) in truncate(hazard.risks, hazard.limit).split('\n')"
                                                                :key="`line-5-${itx}`">
                                                                {{ line }}<br />
                                                            </p>
                                                        </div>
                                                        <div v-if="hazard.controls && hazard.controls != ''" class="legacy-set">
                                                            <p class="bold green">Controls:</p>
                                                            <p
                                                                v-for="(line, ivx) in truncate(hazard.controls, hazard.limit).split('\n')"
                                                                :key="`line-6-${ivx}`">
                                                                {{ line }}<br />
                                                            </p>
                                                        </div>
                                                        <div
                                                            v-if="
                                                                hazard.risks &&
                                                                hazard.controls &&
                                                                (hazard.risks.length > hazard.limit || hazard.controls.length > hazard.limit)
                                                            "
                                                            class="toggler">
                                                            Click to {{ !hazard.show ? 'Show' : 'Hide' }}
                                                        </div>
                                                    </div>
                                                </td>
                                            </tr>
                                            <tr>
                                                <td
                                                    style="
                                                        border-collapse: collapse;
                                                        width: 30% !important;
                                                        max-width: 280px !important;
                                                        border: 1px solid #e1e1e1 !important;
                                                        padding: 10px !important;
                                                    ">
                                                    Likelihood / Consequence
                                                </td>
                                                <td
                                                    style="
                                                        width: 70% !important;
                                                        border-collapse: collapse;
                                                        border: 1px solid #e1e1e1 !important;
                                                        padding: 10px !important;
                                                    ">
                                                    <span>
                                                        {{ hazard.newLikelihood ? hazard.newLikelihood.label : '' }} /
                                                        {{ hazard.newConsequence ? hazard.newConsequence.label : '' }}
                                                    </span>
                                                </td>
                                            </tr>
                                            <tr>
                                                <td
                                                    style="
                                                        border-collapse: collapse;
                                                        width: 30% !important;
                                                        max-width: 280px !important;
                                                        border: 1px solid #e1e1e1 !important;
                                                        padding: 10px !important;
                                                    ">
                                                    Residual Risk Rating
                                                </td>
                                                <td
                                                    style="
                                                        width: 70% !important;
                                                        border-collapse: collapse;
                                                        border: 1px solid #e1e1e1 !important;
                                                        padding: 10px !important;
                                                        text-transform: uppercase;
                                                    "
                                                    class="risk-rating"
                                                    :style="{ 'background-color': ratingColor(hazard.newRating) }">
                                                    {{ hazard.newRating }}
                                                </td>
                                            </tr>
                                            <tr>
                                                <td
                                                    style="
                                                        border-collapse: collapse;
                                                        width: 30% !important;
                                                        max-width: 280px !important;
                                                        border: 1px solid #e1e1e1 !important;
                                                        padding: 10px !important;
                                                    ">
                                                    Responsibility
                                                </td>
                                                <td
                                                    style="
                                                        width: 70% !important;
                                                        border-collapse: collapse;
                                                        border: 1px solid #e1e1e1 !important;
                                                        padding: 10px !important;
                                                    ">
                                                    {{ responsibleList(hazard.personResponsible) }}
                                                </td>
                                            </tr>
                                            <tr v-if="hazard.uploadUrls && hazard.uploadUrls.length > 0">
                                                <td
                                                    style="
                                                        border-collapse: collapse;
                                                        width: 30% !important;
                                                        max-width: 280px !important;
                                                        border: 1px solid #e1e1e1 !important;
                                                        padding: 10px !important;
                                                    ">
                                                    Pictures
                                                </td>
                                                <td
                                                    style="
                                                        width: 70% !important;
                                                        border-collapse: collapse;
                                                        border: 1px solid #e1e1e1 !important;
                                                        padding: 10px !important;
                                                    ">
                                                    <div class="spacer s30"></div>
                                                    <div v-if="!hideImages" class="image-div">
                                                        <ul class="uploads">
                                                            <li v-for="image in hazard.uploadUrls" :key="image.id">
                                                                <div class="image-wrap" v-if="!hideAllImages">
                                                                    <img :src="image" />
                                                                </div>
                                                            </li>
                                                        </ul>
                                                    </div>
                                                </td>
                                            </tr>
                                            <tr v-if="reviewMode">
                                                <td colspan="2">
                                                    <div class="buttons right">
                                                        <!-- <span class="button is-small is-light">
                                                            <font-awesome-icon icon="check-square" /> &nbsp; Mark as Reviewed
                                                        </span> -->
                                                        <span
                                                            class="button is-small"
                                                            :class="[
                                                                finalReviewMap[hazard.id]?.notes && finalReviewMap[hazard.id]?.notes.length > 0
                                                                    ? 'is-primary'
                                                                    : 'is-light'
                                                            ]"
                                                            @click="addAuditNote(false, 'hazards', hazard)">
                                                            <font-awesome-icon icon="pen" /> &nbsp; Add Audit Notes
                                                        </span>
                                                    </div>
                                                </td>
                                            </tr>
                                            <tr>
                                                <td
                                                    style="
                                                        border-collapse: collapse;
                                                        width: 30% !important;
                                                        max-width: 280px !important;
                                                        border: 1px solid #e1e1e1 !important;
                                                        padding: 10px !important;
                                                    ">
                                                    Last Edit
                                                </td>
                                                <td
                                                    style="
                                                        width: 70% !important;
                                                        border-collapse: collapse;
                                                        border: 1px solid #e1e1e1 !important;
                                                        padding: 10px !important;
                                                        font-style: italic !important;
                                                    ">
                                                    {{
                                                        hazard?.versionDate
                                                            ? simpleDate(new Date(hazard.versionDate._seconds * 1000), true, true)
                                                            : ''
                                                    }}
                                                    ({{ hazard.savedByName ?? 'Unknown' }})
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>

                            <!-- log activity content ================================= -->
                            <div v-if="section.type == 'log-activity'">
                                <a :id="'section-' + section.index" class="anchor"></a>
                                <h4 style="color: cadetblue; text-transform: uppercase; font-weight: bold; font-size: 1.1rem; margin-bottom: 8px">
                                    <font-awesome-icon :icon="section.icon" /> &nbsp; {{ section.title }}
                                </h4>
                                <table class="table is-fullwidth set-col" style="border-spacing: 0 !important; table-layout: fixed">
                                    <tr v-for="(row, idx) in section.content" :key="`log-${idx}`">
                                        <td
                                            style="
                                                width: 30% !important;
                                                max-width: 280px !important;
                                                border-bottom: 1px solid #e1e1e1 !important;
                                                padding: 10px !important;
                                                vertical-align: top;
                                            ">
                                            <div class="log-timestamp">{{ simpleDate(row.timestamp, false, true) }}</div>
                                            <div class="log-user">{{ row.userName }}</div>
                                        </td>
                                        <td
                                            style="
                                                width: 70% !important;
                                                border-bottom: 1px solid #e1e1e1 !important;
                                                padding: 10px !important;
                                                vertical-align: top;
                                            ">
                                            <p v-for="(line, ilx) in (row.details || '').split('\n')" :key="`log-line-${idx}-${ilx}`">{{ line }}</p>
                                        </td>
                                    </tr>
                                </table>
                            </div>

                            <!-- general collection content ================================= -->
                            <div v-if="section.type == 'collection'">
                                <a :id="'section-' + section.index" class="anchor"></a>
                                <h4 style="color: cadetblue; text-transform: uppercase; font-weight: bold; font-size: 1.1rem; margin-bottom: 8px">
                                    <font-awesome-icon :icon="section.icon" /> &nbsp; {{ section.title }}
                                </h4>
                                <table class="table is-fullwidth set-col" style="border-spacing: 0 !important; table-layout: fixed">
                                    <tr v-for="(row, idx) in sorted(section.content)" :key="`row-4-${idx}`">
                                        <td
                                            style="
                                                width: 30% !important;
                                                max-width: 280px !important;
                                                border-bottom: 1px solid #e1e1e1 !important;
                                                padding: 10px;
                                            ">
                                            <div>{{ row.title }}</div>
                                            <div v-if="row.status == 'draft'" class="tag is-danger caps">DRAFT CONTENT</div>
                                        </td>
                                        <td style="width: 70% !important; border-bottom: 1px solid #e1e1e1 !important; padding: 10px">
                                            <div
                                                class="toggle-content"
                                                :class="{ show: row.show || showAllContent }"
                                                @click="
                                                    row.show = !row.show;
                                                    row.limit = row.show || showAllContent ? 10000 : 200;
                                                ">
                                                <div v-if="row.details">
                                                    <div v-if="row.hasRichText">
                                                        <div v-html="sanitizeHtml(row.details)" class="details rich-text"></div>
                                                    </div>
                                                    <div v-else>
                                                        <p v-for="(line, itx) in truncate(row.details, row.limit).split('\n')" :key="`line-4-${itx}`">
                                                            {{ line }}
                                                        </p>
                                                    </div>
                                                    <div class="version-date italic">
                                                        ({{
                                                            row?.versionDate ? simpleDate(new Date(row.versionDate._seconds * 1000), true, true) : ''
                                                        }}
                                                        - {{ row.savedByName ?? 'Unknown' }})
                                                    </div>
                                                </div>
                                                <div v-if="row.details && row.details.length > row.limit" class="toggler">
                                                    Click to {{ !row.show ? 'Show' : 'Hide' }}
                                                </div>
                                            </div>
                                            <div v-if="reviewMode">
                                                <div class="buttons right">
                                                    <!-- <span class="button is-small is-light">
                                                        <font-awesome-icon icon="check-square" /> &nbsp; Mark as Reviewed
                                                    </span> -->
                                                    <span
                                                        class="button is-small"
                                                        :class="[
                                                            finalReviewMap[row.id]?.notes && finalReviewMap[row.id]?.notes.length > 0
                                                                ? 'is-primary'
                                                                : 'is-light'
                                                        ]"
                                                        @click="addAuditNote(false, row.reviewSlug ?? 'collection', row)">
                                                        <font-awesome-icon icon="pen" /> &nbsp; Add Audit Notes
                                                    </span>
                                                </div>
                                                <!-- {{ row }} -->
                                            </div>
                                        </td>
                                    </tr>
                                </table>
                            </div>
                        </div>
                    </div>

                    <div class="floaters hideForPrint">
                        <div
                            v-if="formMeta.reviewEnabled && !reviewMode"
                            class="side-icon edit-icon"
                            :class="{ reviewActive: reviewMode }"
                            @click="setupReviewMode()">
                            <font-awesome-icon :icon="reviewMode ? 'list-ul' : 'pen'" />
                        </div>
                        <div class="side-icon expand-icon" @click="showAllContent = !showAllContent">
                            <font-awesome-icon :icon="showAllContent ? 'chevron-up' : 'chevron-down'" />
                        </div>
                        <div class="side-icon print-icon" :class="{ loading: generatingPDF }" @click="savePDFEndpoint()">
                            <span v-if="generatingPDF"><font-awesome-icon icon="spinner" class="fa-spin 3x" /></span>
                            <span v-else><font-awesome-icon icon="print" /></span>
                        </div>
                        <div class="side-icon notes-icon" @click="showNotes = true"><font-awesome-icon icon="info-circle" /></div>
                        <div class="side-icon contents-icon" @click="showContents = true"><font-awesome-icon icon="list-ul" /></div>
                    </div>
                </div>
                <div v-else class="column">
                    <div class="spacer s30"></div>
                    {{ formMessage }}
                </div>
            </div>
            <div v-else class="columns">
                <div class="spacer s30"></div>
                {{ errorMessage }}
            </div>

            <div v-if="formLoaded && accessAllowed" class="buttons floating hideForPrint"></div>

            <div class="modal modal-fx-fadeInScale hideForPrint" v-bind:class="{ 'is-active': showContents }">
                <div class="modal-background" @click="close"></div>
                <div class="modal-card">
                    <header class="modal-card-head is-primary">
                        <p class="modal-card-title">Contents</p>
                    </header>
                    <section class="modal-card-body">
                        <ul class="contents">
                            <li v-for="(item, idx) in contents" :key="`li-${idx}`" @click="showContents = false">
                                <a :href="'#section-' + item.index" v-smooth-scroll="{ offset: -100 }" class="">
                                    <font-awesome-icon :icon="item.icon" /> &nbsp; {{ item.title }}
                                </a>
                            </li>
                        </ul>
                    </section>
                    <footer class="modal-card-foot">
                        <button class="button is-primary" @click="close">Close</button>
                    </footer>
                </div>
            </div>

            <div class="modal modal-fx-fadeInScale hideForPrint" v-bind:class="{ 'is-active': showReviewNoteModal }">
                <div class="modal-background" @click="close"></div>
                <div class="modal-card">
                    <header class="modal-card-head is-primary">
                        <p class="modal-card-title">Audit Notes</p>
                    </header>
                    <section class="modal-card-body">
                        <div class="field">
                            <label class="label">Audit Notes:</label>
                            <div class="control">
                                <textarea
                                    class="textarea"
                                    placeholder="Type any notes for this item..."
                                    maxlength="1000"
                                    v-model="selectedReviewItem.notes"></textarea>
                            </div>
                        </div>
                        <div class="buttons">
                            <button
                                v-for="(item, idx) in quickReviewNotes"
                                :key="`quick-review-note-${idx}`"
                                class="button is-small"
                                :class="item.class"
                                @click="selectedReviewItem.notes = item.value">
                                {{ item.label }}
                            </button>
                        </div>
                    </section>
                    <footer class="modal-card-foot">
                        <button class="button is-dark" @click="close">Cancel</button>
                        <button
                            class="button"
                            :disabled="selectedReviewItem.notes == ''"
                            :class="[selectedReviewItem.notes == '' ? 'is-info' : 'is-primary', { 'is-loading': savingReviewItem }]"
                            @click="saveReviewItem()">
                            Save Notes
                        </button>
                    </footer>
                </div>
            </div>

            <div class="modal modal-fx-fadeInScale hideForPrint" v-bind:class="{ 'is-active': showNotes }">
                <div class="modal-background" @click="close"></div>
                <div class="modal-card">
                    <header class="modal-card-head is-primary">
                        <p class="modal-card-title">Important Notes</p>
                    </header>
                    <section class="modal-card-body">
                        {{ formMeta.notes }}
                    </section>
                    <footer class="modal-card-foot">
                        <button class="button is-primary" @click="close">Close</button>
                    </footer>
                </div>
            </div>

            <SimpleModal
                v-if="showStartReview"
                @closed="close"
                title="SMS audit information"
                theme="is-primary"
                cancelText="Cancel"
                showCancel
                showComplete
                :disabled="userProfile.username.length < 8 || !emailValid"
                :completeText="selectedSavedReview != '' ? 'Resume Audit' : 'Start New Audit'"
                :showLoading="creatingReviewDocument"
                @submit="startReview()">
                <div class="form-group">
                    <label class="label">Your name:</label>
                    <div class="field">
                        <input type="text" class="input padded" v-model="userProfile.username" placeholder="Type your name.." />
                    </div>
                    <label class="label">Your email address:</label>
                    <div class="field">
                        <input
                            type="email"
                            class="input padded"
                            :class="{ red: !emailValid }"
                            v-model="userProfile.useremail"
                            placeholder="Type your email.." />
                    </div>
                    <div v-if="selectedSavedReview == ''">
                        <label class="label">Audit title:</label>
                        <div class="field">
                            <input type="text" class="input padded" v-model="userProfile.auditTitle" placeholder="Type the audit title.." />
                        </div>
                    </div>
                </div>
                <div class="spacer s20"></div>
            </SimpleModal>

            <SimpleModal
                v-if="showReviewNotes"
                @closed="close"
                title="General Audit Notes"
                theme="is-primary"
                cancelText="Cancel"
                showCancel
                showComplete
                completeText="Save Notes"
                :showLoading="creatingReviewDocument"
                @submit="saveGeneralNotes()">
                <label class="label"></label>
                <textarea class="textarea" name="generalNotes" id="generalNotes" v-model="generalNotes"></textarea>
            </SimpleModal>

            <SimpleModal
                v-if="showPreviewModal"
                @closed="close"
                title="Audit Notes"
                theme="is-primary"
                cancelText="Cancel"
                showCancel
                showComplete
                completeText="Save and Finish"
                :showLoading="creatingReviewDocument"
                @submit="finalSaveReview()">
                <label class="label">You are saving the following audit notes:</label>
                <div class="box">
                    <table class="table clean is-fullwidth">
                        <tbody>
                            <tr>
                                <th>Your name</th>
                                <td>{{ userProfile.username }}</td>
                            </tr>
                            <tr>
                                <th>Audit ID</th>
                                <td>{{ userProfile.currentReviewDocID }}</td>
                            </tr>
                            <tr>
                                <th>General notes</th>
                                <td>{{ truncate(generalNotes, 100) }}</td>
                            </tr>
                            <tr>
                                <th>Items reviewed</th>
                                <td>{{ Object.values(this.finalReviewMap).length }}</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
                <div class="spacer s10"></div>
            </SimpleModal>

            <SimpleModal v-if="showImageModal" :fullWidth="false" cancelText="Close" showCancel @closed="showImageModal = false" theme="is-primary">
                <img :src="modalImageUrl" style="max-width: 100%; display: block; margin: 0 auto" />
            </SimpleModal>

            <div class="spacer s100"></div>
        </div>
    </div>
</template>

<script>
import { db } from '../main.js';
import { sanitizeHtml } from '@/utilities/helperFunctions';
import {
    collection,
    query,
    where,
    doc,
    addDoc,
    getDocs,
    getDoc,
    orderBy,
    limit,
    updateDoc,
    setDoc,
    serverTimestamp,
    writeBatch,
    arrayUnion
} from 'firebase/firestore';
import NProgress from 'nprogress';
import { getFunctions, httpsCallable } from 'firebase/functions';

import { confirmPasswordReset } from 'firebase/auth';
import axios from 'axios';
import { version } from 'nprogress';
var FileSaver = require('file-saver');
const SimpleModal = () => import('../reusables/SimpleModal.vue');

const functions = getFunctions();
const aus_functions = getFunctions(undefined, 'australia-southeast1');
const cloudFunctionSendMultipleEmails = httpsCallable(functions, 'cloudFunctionSendMultipleEmails');
const loadSharedSmsContent = httpsCallable(aus_functions, 'asset_functions-loadSharedSmsContent');
const savePublicSmsReview = httpsCallable(aus_functions, 'asset_functions-savePublicSmsReview');
const loadPublicSmsReview = httpsCallable(aus_functions, 'asset_functions-loadPublicSmsReview');

export default {
    props: {
        webLink: String
    },

    mounted() {
        let hasParam = this.$route.query && this.$route.query.x;
        if (hasParam) {
            this.tokenID = this.$route.query.x ? this.$route.query.x : '';
            this.selectedSavedReview = this.$route.query.auditid ? this.$route.query.auditid : '';
        } else {
            this.tokenID = this.webLink ? this.webLink : ''; // ?
        }
        let self = this;
        if (this.tokenID != '') {
            this.checkCodeExists();
        } else {
            setTimeout(() => {
                self.checkingDetails = false;
                self.status = 'No access token found.';
                self.errorMessage = 'No access token found.';
            }, 1000);
        }
        if (this.selectedSavedReview != '') {
            this.loadActiveReview();
        }
        // this.getIP();
        this.getIPFromAmazon();
    },

    components: {
        SimpleModal
    },

    computed: {
        user() {
            return this.$store.getters.getUser;
        },
        isLoggedIn() {
            return this.user && this.user.uid && this.user.uid != '';
        },
        userData() {
            return this.$store.getters.getSubscriptionInfo;
        },
        userID() {
            return this.userData.userid;
        },
        userFirstName() {
            return this.userData.username.split(' ')[0];
        },
        contents() {
            return this.displaySections.map((m) => {
                return {
                    index: m.index,
                    title: m.title,
                    icon: m.icon
                };
            });
        },
        emailValid() {
            const v = (this.userProfile.useremail || '').trim();
            return v === '' ? false : this.reg.test(v);
            // If you don't want the warning when empty, return true instead of false.
        }
    },

    data: function () {
        return {
            currentWebLink: '',
            reg: /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@(([[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,24}))$/,
            checkingDetails: true,
            formExists: false,
            loadingSavedData: false,
            ipAddress: '',
            hasData: false,
            status: 'Checking if content exists..',
            formMessage: '',
            formLoaded: false,
            errorMessage: '',
            formMeta: {},
            formData: {},
            tokenID: '',
            accessAllowed: false,
            currentVesselID: '',
            currentVesselName: '',
            vesselOwnerID: '',
            errorMsg: '',
            displaySections: [],
            vesselData: {},
            fleetData: {},
            hideAllImages: false,
            showNotes: false,

            showImageModal: false,
            modalImageUrl: '',

            showContents: false,
            ownerRows: [
                { label: 'Vessel Owner', field: 'vesselOwnerName' },
                { label: 'Owner Contact Number', field: 'vesselOwnerPhone' },
                { label: 'Owner Email Address', field: 'vesselOwnerEmail' },
                { label: 'Designated Person', field: 'designatedPerson' }
            ],
            statementRows: [
                { label: 'Owner Responsibility Statement', field: 'ownerStatement' },
                { label: 'Designated Person Responsibility Statement', field: 'designatedStatement' },
                { label: 'General Statement', field: 'customStatement' },
                { label: 'Line of Communication Statement', field: 'lineOfComms' }
            ],
            overviewRows: [
                { label: 'Vessel Name', field: 'vesselName' },
                { label: 'Vessel Identifier', field: 'vesselUVI' },
                { label: 'Description', field: 'vesselDescription' },
                { label: 'Location', field: 'homePort' },
                { label: 'Class Information', field: 'vesselClass' },
                { label: 'Operational Area', field: 'vesselOperationalArea' },
                { label: 'Propulsion', field: 'vesselPropulsion' },
                { label: 'Minimum Crew', field: 'vesselMinCrew' },
                { label: 'Appropriate Crew', field: 'vesselCrew' },
                { label: 'Crewing Explanation', field: 'appCrewExplanation' }
            ],
            collections: {
                hazards: {
                    collection: 'smsHazards',
                    versions: 'smsHazardsVersions',
                    fleetCollection: 'companyHazards',
                    fleetVersions: 'companyHazardsVersions',
                    savedCollection: 'savedCompanyHazards'
                },
                policies: {
                    collection: 'smsPolicies',
                    versions: 'smsPoliciesVersions',
                    fleetCollection: 'companyPolicies',
                    fleetVersions: 'companyPoliciesVersions',
                    savedCollection: 'savedCompanyPolicies'
                },
                contacts: {
                    collection: 'smsContacts',
                    versions: 'smsContactsVersions',
                    fleetCollection: 'companyContacts',
                    fleetVersions: 'companyContactsVersions',
                    savedCollection: 'savedCompanyContacts'
                },
                sops: {
                    collection: 'smsSOPS',
                    versions: 'smsSOPSVersions',
                    fleetCollection: 'companySOPS',
                    fleetVersions: 'companySOPSVersions',
                    savedCollection: 'savedCompanySOPS'
                },
                eops: {
                    collection: 'smsEOPS',
                    versions: 'smsEOPSVersions',
                    fleetCollection: 'companyEOPS',
                    fleetVersions: 'companyEOPSVersions',
                    savedCollection: 'savedCompanyEOPS'
                },
                startups: {
                    collection: 'smsStartupItems',
                    versions: 'smsStartupItemsVersions',
                    fleetCollection: 'companyStartupItems',
                    fleetVersions: 'companyStartupItemsVersions',
                    savedCollection: 'savedCompanyStartupItems'
                },
                shutdowns: {
                    collection: 'smsShutdownItems',
                    versions: 'smsShutdownItemsVersions',
                    fleetCollection: 'companyShutdownItems',
                    fleetVersions: 'companyShutdownItemsVersions',
                    savedCollection: 'savedCompanyShutdownItems'
                },
                maintenance: {
                    collection: 'smsMaintenanceItems',
                    versions: 'smsMaintenanceItemsVersions',
                    fleetCollection: 'companyMaintenanceItems',
                    fleetVersions: 'companyMaintenanceItemsVersions',
                    savedCollection: 'savedCompanyMaintenanceItems'
                },
                inductions: {
                    collection: 'smsVesselInductionItems',
                    versions: 'smsVesselInductionItemsVersions',
                    fleetCollection: 'companyInductionItems',
                    fleetVersions: 'companyInductionItemsVersions',
                    savedCollection: 'savedCompanyInductionItems'
                },
                briefings: {
                    collection: 'smsPassengerInductionItems',
                    versions: 'smsPassengerInductionItemsVersions',
                    fleetCollection: 'companyPassengerInductionItems',
                    fleetVersions: 'companyPassengerInductionItemsVersions',
                    savedCollection: 'savedCompanyPassengerInductionItems'
                },
                statements: {
                    collection: 'smsAssetStatements',
                    versions: 'smsAssetStatementsVersions',
                    fleetCollection: 'fleetStatements',
                    fleetVersions: 'fleetStatementsVersions',
                    savedCollection: 'savedCompanyAssetStatements'
                },
                'general-statements': {
                    collection: 'smsAssetStatements',
                    versions: 'smsAssetStatementsVersions',
                    fleetCollection: 'fleetStatements',
                    fleetVersions: 'fleetStatementsVersions',
                    savedCollection: 'savedCompanyAssetStatements'
                }
            },
            showLogo: false,
            generatingPDF: false,
            buttonText: 'Generate PDF',
            showAllContent: false,
            reviewMode: false,
            hideImages: false,
            vesselIsSimple: false,
            selectedReviewItem: {},
            quickReviewNotes: [
                { label: 'Remove', value: 'This item can be removed - not relevant or redundant', class: 'is-danger' },
                { label: 'Approved', value: 'This item has been reviewed and approved', class: 'is-success' },
                { label: 'Needs Update', value: 'This item needs to be updated with new information', class: 'is-warning' },
                { label: 'Needs Review', value: 'This item requires further review and discussion', class: 'is-info' },
                { label: 'Simplify', value: 'This item needs simplification to improve readability - consider AI tool', class: 'is-primary' },
                { label: 'Content missing', value: 'More information is needed for this item', class: 'is-link' },
                { label: 'Duplicated', value: 'This is a duplication of another similar item', class: 'is-dark' }
            ],
            showReviewNoteModal: false,
            finalReviewMap: {},
            showStartReview: false,
            userProfile: {
                verified: true,
                username: '',
                useremail: '',
                userphone: '',
                otpCode: '',
                currentReviewDocID: '',
                auditTitle: ''
            },
            creatingReviewDocument: false,
            showReviewNotes: false,
            generalNotes: '',
            showPreviewModal: false,
            mySavedReviews: [],
            selectedSavedReview: '',
            savingReviewItem: false,

            avatarUrl: ''
        };
    },

    methods: {
        ratingColor(rating) {
            const colors = { low: '#23d160', medium: '#F3DD4A', high: '#ffaa00', extreme: '#ff3860' };
            return colors[rating] || '#23d160';
        },
        sanitizeHtml(dirty) {
            return sanitizeHtml(dirty);
        },
        close() {
            this.errorMsg = '';
            this.showNotes = false;
            this.showContents = false;
            this.showReviewNoteModal = false;
            this.selectedReviewItem = {};
            this.showStartReview = false;
            this.showReviewNotes = false;
            this.showPreviewModal = false;
            this.savingReviewItem = false;
        },

        sorted(arr) {
            // Set slice() to avoid to generate an infinite loop!
            return arr.slice().sort(function (a, b) {
                return a.index - b.index;
            });
        },

        truncate(string, limit) {
            if (string == undefined || string == '') return '';
            return this.showAllContent ? string : string.length > limit ? string.slice(0, limit) + '...' : string;
        },

        responsibleList(array) {
            if (array && (array.length == 0 || array == undefined)) return;
            return Array.isArray(array) ? array.join(', ') : array;
        },

        toDate(val) {
            if (!val) return new Date();
            if (val.toDate) return val.toDate();
            if (val._seconds) return new Date(val._seconds * 1000);
            return new Date(val);
        },

        simpleDate(sentDate, isDate, full) {
            if (sentDate && (typeof sentDate == 'string' || typeof sentDate == 'number')) return sentDate;
            const longOptions = { month: 'short', day: 'numeric', year: 'numeric', hour: 'numeric', minute: 'numeric' };
            const shortOptions = { month: 'short', day: 'numeric', year: 'numeric' };
            const dateOptions = full ? longOptions : shortOptions;
            if (!sentDate || sentDate == '') return '';
            const d = isDate ? sentDate : this.toDate(sentDate);
            return d.toLocaleDateString('en-US', dateOptions);
        },

        openImageModal(url) {
            this.modalImageUrl = url;
            this.showImageModal = true;
        },

        timeLeft(expiryDate) {
            let now = new Date().getTime();
            let t = new Date(expiryDate).getTime();
            let diff = Math.round((t - now) / (1000 * 60 * 60 * 24));
            return diff;
        },

        async getIPFromAmazon() {
            fetch('https://checkip.amazonaws.com/')
                .then((res) => res.text())
                .then((data) => {
                    this.ipAddress = data;
                });
        },

        async loadActiveReview() {
            // load general notes
            // load reviewedContentIDs
            // loop through reviewedItems docs and populate locally
        },

        async checkCodeExists() {
            this.errorMessage = '';

            try {
                const showDraft = this.$route.query.draft === 'yes';
                // console.log('showDraft', showDraft);
                const result = await loadSharedSmsContent({ tokenID: this.tokenID, showDraft });
                const data = result.data;

                if (!data.success) {
                    this.checkingDetails = false;
                    this.status = 'This content could not be loaded.';
                    this.errorMessage = 'No content found.';
                    return;
                }

                // Populate formMeta from token data
                let tokenData = data.tokenData;
                tokenData.isCurrent = data.isCurrent;
                tokenData.archived = data.archived;
                this.formMeta = tokenData;
                this.currentVesselName = data.vesselName;
                this.currentVesselID = data.vesselID;
                this.vesselData = data.vesselData ?? {};
                this.vesselOwnerID = data.vesselOwnerID ?? this.vesselData.vesselOwnerID ?? '';
                this.fleetData = data.fleetData ?? {};

                if (data.vesselID) {
                    let vesselID = data.vesselID;
                    this.$store.dispatch('setCurrentVessel', { vesselID });
                }
                let logMeta = this.formMeta;
                this.$store.dispatch('setCurrentTokenMeta', { logMeta });

                this.status = 'Checking status...';
                this.formExists = true;
                this.loadingSavedData = true;
                this.checkingDetails = false;

                if (!this.formMeta.sharedToken || this.formMeta.sharedToken == '') {
                    this.formMessage = 'Unable to load content, sorry.';
                    this.loadingSavedData = false;
                    this.formLoaded = true;
                    return;
                }

                this.hasData = true;
                this.status = 'Loading shared content...';

                // Snapshot (immutable) path
                if (data.isImmutable && data.snapshotData) {
                    this.buildSnapshotSections(data.snapshotData);
                    return;
                }

                // Live path
                if (!data.isCurrent || data.archived) {
                    this.formMessage = 'This content has expired, sorry.';
                    this.loadingSavedData = false;
                    this.formLoaded = true;
                    return;
                }

                let aaaPlans = this.vesselData.aaaPlans ?? [];
                this.vesselIsSimple = aaaPlans.includes('sms') && !aaaPlans.includes('pro');
                this.buildLiveSections(data.liveData ?? {});
            } catch (error) {
                this.checkingDetails = false;
                this.status = 'This content could not be loaded.';
                this.errorMessage = 'No content found.';
            }
        },

        buildSnapshotSections(snapshotData) {
            const sections = snapshotData.sections || {};
            const sectionMeta = snapshotData.sectionMeta || {};
            const itemsBySlug = snapshotData.itemsBySlug || {};
            this.showLogo = snapshotData.showLogo || false;

            const checkedItems = (snapshotData.sharedContent || []).filter((k) => k.checked);
            checkedItems.forEach((item, index) => {
                if (item.slug === 'intro' && sections.intro) {
                    this.displaySections.push({
                        type: 'para',
                        content: sections.intro.content,
                        title: 'About this Safety Management System',
                        icon: item.icon,
                        index,
                        reviewSlug: 'intro'
                    });
                }
                if (item.slug === 'owner-info' && sections['owner-info']) {
                    this.displaySections.push({
                        type: 'table',
                        content: sections['owner-info'].rows,
                        title: 'Owner Information',
                        icon: item.icon,
                        index,
                        reviewSlug: 'owner-info'
                    });
                }
                if (item.slug === 'asset-overview' && sections['asset-overview']) {
                    this.displaySections.push({
                        type: 'table',
                        content: sections['asset-overview'].rows,
                        title: 'Asset Overview',
                        icon: item.icon,
                        index,
                        reviewSlug: 'asset-overview'
                    });
                }
                if (item.slug === 'asset-roles' && sections['asset-roles']) {
                    const roles = sections['asset-roles'].roles || [];
                    roles.forEach((role) => {
                        (role.statements || []).forEach((stmt) => {
                            stmt.show = false;
                            stmt.limit = 200;
                        });
                    });
                    this.displaySections.push({
                        type: 'table-statements',
                        content: roles,
                        title: 'Team Roles',
                        icon: item.icon,
                        index,
                        reviewSlug: 'asset-roles'
                    });
                }
                if (item.type === 'hazards' && itemsBySlug['hazards']) {
                    const content = itemsBySlug['hazards'];
                    content.forEach((r) => {
                        r.show = false;
                        r.limit = 200;
                    });
                    this.displaySections.push({
                        type: 'hazards',
                        content,
                        title: sectionMeta['hazards']?.title || item.label,
                        icon: item.icon,
                        index
                    });
                }
                if (item.type === 'collection' && itemsBySlug[item.slug]) {
                    const content = itemsBySlug[item.slug];
                    content.forEach((r) => {
                        r.show = false;
                        r.limit = 200;
                    });
                    this.displaySections.push({
                        type: 'collection',
                        content,
                        title: item.label,
                        icon: item.icon,
                        index
                    });
                }
                if (item.type === 'plant' && itemsBySlug['plant']) {
                    this.displaySections.push({
                        type: 'plant',
                        content: itemsBySlug['plant'],
                        title: 'Plant & Equipment Register',
                        icon: item.icon,
                        index
                    });
                }
                if (item.type === 'drill' && itemsBySlug['drill']) {
                    this.displaySections.push({
                        type: 'drill',
                        content: itemsBySlug['drill'],
                        title: 'Drills & Training Schedules',
                        icon: item.icon,
                        index
                    });
                }
                if (item.type === 'logActivity' && sections.logActivity) {
                    this.displaySections.push({
                        type: 'log-activity',
                        content: sections.logActivity.items || [],
                        title: 'Recent Log Activity',
                        icon: item.icon,
                        index
                    });
                }
            });

            this.accessAllowed = true;
            this.loadingSavedData = false;
            this.formLoaded = true;
        },

        buildLiveSections(liveData) {
            const self = this;
            const checkedItems = (this.formMeta.sharedContent || []).filter((k) => k.checked);

            checkedItems.forEach((item, index) => {
                if (item.slug === 'logo') self.showLogo = true;

                if (item.slug === 'intro') {
                    self.displaySections.push({
                        type: 'para',
                        content: self.vesselData.snapshotIntro ?? '',
                        title: 'About this Safety Management System',
                        icon: item.icon,
                        index,
                        reviewSlug: 'intro'
                    });
                }
                if (item.slug === 'owner-info') {
                    self.displaySections.push({
                        type: 'table',
                        content: self.getOwnerData(),
                        title: 'Owner Information',
                        icon: item.icon,
                        index,
                        reviewSlug: 'owner-info'
                    });
                }
                if (item.slug === 'asset-overview') {
                    self.displaySections.push({
                        type: 'table',
                        content: self.getOverviewData(),
                        title: 'Asset Overview',
                        icon: item.icon,
                        index,
                        reviewSlug: 'asset-overview'
                    });
                }
                if (item.slug === 'asset-roles' && liveData.roles) {
                    const tableRows = liveData.roles;
                    tableRows.forEach((role) => {
                        (role.statements ?? []).forEach((stmt) => {
                            stmt.show = false;
                            stmt.limit = 200;
                        });
                    });
                    self.displaySections.push({
                        type: 'table-statements',
                        content: tableRows,
                        title: 'Team Roles',
                        icon: item.icon,
                        index,
                        reviewSlug: 'asset-roles'
                    });
                }
                if (item.type === 'hazards' && liveData.collections?.hazards) {
                    const content = liveData.collections.hazards;
                    content.forEach((r) => {
                        r.show = false;
                        r.limit = 200;
                    });
                    self.displaySections.push({
                        type: 'hazards',
                        content,
                        title: 'Hazards / Risk Assessments',
                        icon: item.icon,
                        index
                    });
                }
                if (item.type === 'collection' && liveData.collections?.[item.slug]) {
                    const content = liveData.collections[item.slug];
                    content.forEach((r) => {
                        r.show = false;
                        r.limit = 200;
                    });
                    self.displaySections.push({
                        type: 'collection',
                        content,
                        title: item.label,
                        icon: item.icon,
                        index
                    });
                }
                if (item.type === 'plant' && liveData.plant) {
                    self.displaySections.push({
                        type: 'plant',
                        content: liveData.plant,
                        title: 'Plant & Equipment Register',
                        icon: item.icon,
                        index
                    });
                }
                if (item.type === 'drill' && liveData.drills) {
                    self.displaySections.push({
                        type: 'drill',
                        content: liveData.drills,
                        title: 'Drills & Training Schedules',
                        icon: item.icon,
                        index
                    });
                }
                if (item.type === 'logActivity' && liveData.logActivity) {
                    self.displaySections.push({
                        type: 'log-activity',
                        content: liveData.logActivity,
                        title: 'Recent Log Activity',
                        icon: item.icon,
                        index
                    });
                }
            });

            this.loadingSavedData = false;
            this.accessAllowed = true;
            this.formLoaded = true;
        },

        getOwnerData() {
            return this.ownerRows.map((row) => ({
                header: row.label,
                content: this.vesselData[row.field] ?? ''
            }));
        },

        getOverviewData() {
            const customFields = (this.vesselData.customFields ?? []).filter((f) => f.isPublic);
            return [
                ...this.overviewRows.map((row) => ({ header: row.label, content: this.vesselData[row.field] ?? '' })),
                ...customFields.map((f) => ({ header: f.label, content: f.value }))
            ];
        },

        setupReviewMode() {
            this.showStartReview = true;
        },

        async startReview() {
            this.creatingReviewDocument = true;
            if (this.selectedSavedReview == '') {
                const result = await savePublicSmsReview({
                    action: 'create',
                    vesselID: this.currentVesselID,
                    reviewData: {
                        username: this.userProfile.username,
                        useremail: this.userProfile.useremail,
                        userphone: this.userProfile.userphone,
                        generalNotes: this.generalNotes,
                        token: this.tokenID ?? '',
                        ownerID: this.formMeta.ownerID ?? '',
                        title: this.userProfile.auditTitle ?? 'Untitled audit'
                    }
                });
                this.userProfile.currentReviewDocID = result.data.docID;
                this.reviewMode = true;
                this.showStartReview = false;
                this.creatingReviewDocument = false;
            } else {
                const result = await loadPublicSmsReview({
                    vesselID: this.currentVesselID,
                    reviewID: this.selectedSavedReview
                });
                if (result.data.found) {
                    const review = result.data.review;
                    this.generalNotes = review.generalNotes;
                    this.userProfile.username = review.username;
                    this.userProfile.useremail = review.useremail;
                    this.userProfile.userphone = review.userphone;
                    this.userProfile.auditTitle = review.title;
                    this.userProfile.currentReviewDocID = this.selectedSavedReview;
                    this.reviewMode = true;
                    this.showStartReview = false;
                    this.creatingReviewDocument = false;
                } else {
                    this.showStartReview = false;
                    this.creatingReviewDocument = false;
                }
            }
        },

        async saveReviewItem() {
            this.savingReviewItem = true;
            if (!this.selectedReviewItem.slug || this.selectedReviewItem.slug == '') {
                this.savingReviewItem = false;
                return;
            }
            await savePublicSmsReview({
                action: 'saveItem',
                vesselID: this.currentVesselID,
                reviewID: this.userProfile.currentReviewDocID,
                reviewItem: {
                    title: this.selectedReviewItem.title ?? '',
                    notes: this.selectedReviewItem.notes ?? 'Item marked as reviewed.',
                    isFleetDoc: this.selectedReviewItem.isFleetDoc ?? false,
                    reviewSlug: this.selectedReviewItem.reviewSlug ?? '',
                    slug: this.selectedReviewItem.slug ?? '',
                    docID: this.selectedReviewItem.docID ?? '',
                    versionID: this.selectedReviewItem.versionID ?? '',
                    updatedBy: this.userProfile.username ?? 'not set',
                    updatedByEmail: this.userProfile.useremail ?? 'not set'
                }
            });
            this.close();
        },

        setupGeneralNotes() {
            this.showPreviewModal = false;
            this.showReviewNotes = true;
        },

        async saveGeneralNotes() {
            this.creatingReviewDocument = true;
            if (this.userProfile.currentReviewDocID == '') return;
            await savePublicSmsReview({
                action: 'updateNotes',
                vesselID: this.currentVesselID,
                reviewID: this.userProfile.currentReviewDocID,
                reviewData: { generalNotes: this.generalNotes }
            });
            this.showReviewNotes = false;
            this.creatingReviewDocument = false;
        },

        previewFinalSave() {
            this.showPreviewModal = true;
        },

        async finalSaveReview() {
            NProgress.start();
            const reviewItems = {};
            for (const [slug, item] of Object.entries(this.finalReviewMap)) {
                if (!slug) continue;
                reviewItems[slug] = {
                    title: item.title ?? '',
                    notes: item.notes ?? '',
                    isFleetDoc: item.isFleetDoc ?? false,
                    reviewSlug: item.reviewSlug ?? '',
                    slug: item.slug ?? '',
                    docID: item.docID ?? '',
                    versionID: item.versionID ?? '',
                    updatedBy: this.userProfile.username ?? 'not set',
                    updatedByEmail: this.userProfile.useremail ?? 'not set'
                };
            }
            await savePublicSmsReview({
                action: 'finalSave',
                vesselID: this.currentVesselID,
                reviewID: this.userProfile.currentReviewDocID,
                reviewItems: reviewItems,
                reviewData: {
                    generalNotes: this.generalNotes,
                    updatedBy: this.userProfile.username ?? 'not set'
                }
            });
            this.showPreviewModal = false;
            this.reviewMode = false;
            NProgress.done();
        },

        async addAuditNote(isWholeSection, type, document) {
            if (!document) return;
            let finalDoc = type == 'drill' || type == 'plant' ? document.content : document;
            let slug = isWholeSection ? type : finalDoc.docID ?? finalDoc.id ?? '';
            let item = {
                slug: slug,
                reviewSlug: type,
                title: finalDoc.title,
                docID: finalDoc.docID,
                versionID: finalDoc.versionID ?? '',
                isFleetDoc: finalDoc.isFleet ? finalDoc.isFleet : finalDoc.isFleetDoc ?? false,
                notes: ''
            };
            if (!this.finalReviewMap[slug]) {
                // console.log('item', item);
                this.finalReviewMap[slug] = item;
            }
            this.selectedReviewItem = this.finalReviewMap[slug];
            this.showReviewNoteModal = true;
        },

        printPDF() {
            this.showAllContent = true;
            this.hideImages = true;
            this.generatingPDF = true;
            this.buttonText = 'Preparing PDF. Please wait...';

            var html = document.documentElement.outerHTML;
            var self = this;

            var css =
                'body {font-size: 13px !important;}\n\n.hideForPrint {display: none !important;}\n\n.main-fleet-content {padding: 1rem 15px !important; margin: 0 !important; width: 100% !important;}\n\n.image-div {display: none !important;}\n\n.box {box-shadow: none !important; border: none !important;}\n\n.header {display: none !important;}\n\nfooter {display: none !important;}\n\n.floaters {display: none !important;}\n\n.image-wrap img {display: none !important}\n\n.box {text-align: left !important; margin-bottom: 3rem !important; border: none !important; box-shadow: none !important; padding: 0 !important;}\n\n p {font-size: 13px !important; line-height: 1.5rem !important; font-weight: 400 !important; font-family: inherit !important; margin-bottom: 0 !important;}\n\n.toggle-content {max-height: none !important;}\n\nh4 {font-size: 1rem !important;font-family: Helvetica, Sans-Serif; !important;}\n\n.main-image {text-align: center !important; max-width: none !important;}\n\ntd {font-size: 13px !important;}\n\nth {font-size: 13px !important;}\n\n.container {max-width: none !important; padding: 1rem 0 !important;}\n\ndiv {font-family: Helvetica, Sans-Serif; !important; font-size: 13px !important; line-height: 16px !important;}\n\n.table tr.first td {width: 30% !important;}\n\n.table {padding-bottom: 20px !important; margin-bottom: 20px !important; width: 100% !important; table-layout: fixed !important;}\n\n.table td {vertical-align: top !important;}\n\n.sms-content .sms-section table.set-col tr td {width: 30% !important;}\n\n.toggler {display: none !important;}\n\n.bold {font-weight: bold !important;}\n\n.red {color: red !important;}\n\n.green {color: mediumseagreen !important;}';
            var data = {
                html: html,
                license: 'E197E92RdrKd',
                css: css,
                orientation: 'Portrait',
                top: 10,
                bottom: 5,
                left: 2,
                right: 2,
                width: 210,
                height: 297,
                unit: 'mm',
                toc: true
            };
            var serialized = Object.keys(data)
                .map(function (k) {
                    return encodeURIComponent(k) + '=' + encodeURIComponent(data[k]);
                })
                .join('&');

            // You can insert an "in progress" message here

            // We now prepare the API call
            var xhttp = new XMLHttpRequest();
            xhttp.onreadystatechange = function () {
                var a;
                if (xhttp.readyState === 4 && xhttp.status === 200) {
                    // The PDF is now generated
                    // You can remove the "in progress" message here

                    // Now we show the PDF to the user
                    a = document.createElement('a');
                    a.href = window.URL.createObjectURL(xhttp.response);
                    a.download = self.currentVesselName + '.pdf';
                    a.style.display = 'none';
                    document.body.appendChild(a);
                    a.click();
                    // console.log('One');
                    this.generatingPDF = false;
                }
            };

            // This is the actual call to our API
            xhttp.open('POST', 'https://pdfmyurl.com/api', true);
            xhttp.setRequestHeader('Content-type', 'application/x-www-form-urlencoded');
            xhttp.responseType = 'blob';
            xhttp.send(serialized);
        },

        // current PDf generator:
        async savePDFEndpoint() {
            // this.showAllContent = !this.showAllContent;
            // return;
            if (this.generatingPDF) return;
            this.showAllContent = true;
            this.hideImages = true;

            const sleep = (milliseconds) => new Promise((resolve) => setTimeout(resolve, milliseconds));
            await sleep(2000);

            this.generatingPDF = true;
            this.buttonText = 'Preparing PDF. Please wait...';
            let html = document.documentElement.outerHTML;
            let self = this;

            try {
                const options = {
                    method: 'POST',
                    url: 'https://api.pdfendpoint.com/v1/convert',
                    headers: {
                        'Content-Type': 'application/json',
                        Authorization: 'Bearer c870f041af1a45c8bb1444834679eb0354ef9e39e8'
                    },
                    data: {
                        // url: 'https://your_url.com',
                        html: html,
                        orientation: 'vertical',
                        page_size: 'A4',
                        zoom: '0.8',
                        css: 'body {font-size: 13px !important;}\n\n.hideForPrint {display: none !important;}\n\n.main-fleet-content {padding: 1rem 15px !important; margin: 0 !important; width: 100% !important;}\n\n.image-div {display: none !important;}\n\n.box {box-shadow: none !important; border: none !important;}\n\n.header {display: none !important;}\n\nfooter {display: none !important;}\n\n.floaters {display: none !important;}\n\n.image-wrap img {display: none !important}\n\n.box {text-align: left !important; margin-bottom: 3rem !important; border: none !important; box-shadow: none !important; padding: 0 !important;}\n\n p {font-size: 13px !important; line-height: 1.5rem !important; font-weight: 400 !important; font-family: inherit !important; margin-bottom: 0 !important;}\n\n.toggle-content {max-height: none !important;}\n\nh4 {font-size: 1rem !important;font-family: Helvetica, Sans-Serif; !important;}\n\n.main-image {text-align: center !important; max-width: none !important;}\n\ntd {font-size: 13px !important;}\n\nth {font-size: 13px !important;}\n\n.container {max-width: none !important; padding: 1rem 0 !important;}\n\ndiv {font-family: Helvetica, Sans-Serif; !important; font-size: 13px !important; line-height: 16px !important;}\n\n.table tr.first td {width: 30% !important;}\n\n.table {padding-bottom: 20px !important; margin-bottom: 20px !important; width: 100% !important; table-layout: fixed !important;}\n\n.table td {vertical-align: top !important;}\n\n.sms-content .sms-section table.set-col tr td {width: 30% !important;}\n\n.toggler {display: none !important;}\n\n.bold {font-weight: bold !important;}\n\n.red {color: red !important;}\n\n.green {color: mediumseagreen !important;}',
                        use_print_media: true,
                        wait_for_network: true,
                        margin_top: '1cm',
                        margin_bottom: '1cm',
                        margin_right: '5mm',
                        margin_left: '5mm',
                        delivery_mode: 'inline'
                    },
                    responseType: 'arraybuffer'
                };

                let response = await axios(options);
                // console.log('response', response);
                // fs.writeFileSync(`./test.pdf`, response.data);
                let blob = new Blob([response.data], {
                    type: 'application/octet-stream'
                });
                FileSaver.saveAs(blob, self.currentVesselName + '-snapshot.pdf');
                self.generatingPDF = false;
            } catch (e) {
                // console.log(e);
            }
        }
    }
};
</script>

<style lang="scss" scoped>
.form-group {
    text-align: left;
}
.container {
    max-width: 1400px !important;
    padding: 1rem 40px !important;
}
.uploads {
    display: flex;
    gap: 10px;
    .image-wrap {
        max-width: 180px;
    }
}

h3 {
    margin-bottom: 8px;
    font-weight: bold;
    font-size: 1.3rem;
    color: cadetblue;
}
h5 {
    font-weight: bold;
    margin: 1.6rem 0 1rem;
}
p {
    line-height: 1.65rem;
    margin-bottom: 7px;
}
.details.rich-text :deep(ol),
.details.rich-text :deep(u) {
    margin-left: 1rem;
}
.details.rich-text :deep(p) {
    margin: 0.5rem 0;
}
.alert-bar {
    width: 100%;
    background-color: orange;
    color: white;
    padding: 12px 20px;
    margin-bottom: 20px;
    position: fixed;
    top: 55px;
    left: 0;
    z-index: 1000;
    display: flex;
    justify-content: space-between;
}
.columns {
    &.padded {
        margin-top: 60px;
    }
}

.sms-content {
    .sms-section {
        text-align: left;
        margin-bottom: 2rem;
        h4 {
            color: cadetblue;
            text-transform: uppercase;
            font-weight: bold;
            font-size: 1.1rem;
            margin-bottom: 8px;
        }
        .main-image {
            width: 100%;
            max-width: 450px;
        }
        table {
            margin-bottom: 2rem;
            &.single-col {
                tr {
                    th,
                    td {
                        width: 100%;
                    }
                    &.first {
                        background: #f9f9f9;
                        th,
                        td {
                            border-bottom: 0;
                        }
                    }
                }
            }
            &.set-col {
                tr {
                    td {
                        &:first-of-type {
                            width: 30%;
                        }
                        .toggle-content {
                            max-height: 100px;
                            overflow: hidden;
                            position: relative;
                            cursor: pointer;
                            .toggler {
                                position: absolute;
                                right: 10px;
                                top: 10px;
                                border-radius: 5px;
                                background: deepskyblue;
                                color: #fff;
                                padding: 3px 8px;
                                opacity: 0;
                                transition: 0.25s;
                                font-size: 12px;
                            }
                            &.show {
                                max-height: none;
                                overflow: visible;
                            }
                            &:hover {
                                .toggler {
                                    opacity: 1;
                                }
                            }
                        }
                    }
                }
            }
            tr {
                &.hidden {
                    display: none;
                }
            }
            &.hidden {
                display: none;
            }
        }
        .drill-freq {
            margin: 10px 0;
        }
        .linked-sms-items {
            margin: 6px 0 10px 30px;
            .lsi-type {
                text-transform: uppercase;
                font-size: 0.8rem;
            }
            .lsi-title {
                font-weight: bold;
            }
        }
    }
}

.asset-avatar {
    margin-right: 1rem;
    width: 150px;
    height: 150px;
    background-position: center center;
    background-size: cover;
    border-radius: 50%;
    cursor: pointer;
    transition: 0.3s;
    &:hover {
        transform: scale(1.05);
    }
}
.top-content {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    .red-heading {
        background-color: rgb(252, 89, 89);
        color: #fff;
        padding: 8px 18px;
        border-radius: 5px;
        margin: 0px 0 1rem;
        display: inline-block;
    }
}

.toggle-content {
    // max-height: 100px;
    overflow: hidden;
    position: relative;
    cursor: pointer;
    .toggler {
        position: absolute;
        right: 10px;
        top: 10px;
        border-radius: 5px;
        background: deepskyblue;
        color: #fff;
        padding: 3px 8px;
        opacity: 0;
        transition: 0.25s;
        font-size: 12px;
    }
    &.show {
        max-height: none;
        overflow: visible;
    }
    &:hover {
        .toggler {
            opacity: 1;
        }
    }
}
.modal .modal-card {
    max-height: 80%;
    max-height: 80vh;
}
.listed {
    margin-left: 40px;
    margin-bottom: 1rem;
    list-style: disc;
    li {
    }
}
.risk-rating {
    color: #fff;
    text-transform: uppercase;
}
.legacy-set {
    margin-bottom: 1.5rem;
}
.risk-pair {
    border-bottom: 1px dashed #e4e4e4;
    padding-bottom: 1rem;
    margin-bottom: 1rem;
    .rp-title {
        font-weight: bold;
    }
    .rp-details {
        margin-left: 10px;
        &:last-of-type {
            margin-bottom: 1rem;
        }
    }
}
.floaters {
    position: relative;
    .side-icon {
        position: fixed;
        color: #fff;
        display: flex;
        justify-content: center;
        align-items: center;
        padding: 20px;
        cursor: pointer;
        transition: 0.25s;
        border-radius: 50%;
        width: 56px;
        height: 56px;
        &:hover {
            transform: scale(1.1);
        }
        &.notes-icon {
            bottom: 20px;
            right: 20px;
            background-color: cadetblue;
        }
        &.contents-icon {
            bottom: 90px;
            right: 20px;
            background-color: blueviolet;
        }
        &.print-icon {
            // display: none;
            bottom: 160px;
            right: 20px;
            background-color: #c6c6c6;
            &.loading {
                background-color: hotpink;
            }
        }
        &.expand-icon {
            bottom: 230px;
            right: 20px;
            background-color: orange;
        }
        &.edit-icon {
            bottom: 300px;
            right: 20px;
            background-color: #00d1b2;
            &.reviewActive {
                background-color: orangered;
            }
        }
    }
}

.contents {
    text-align: left;
    margin: 1rem 1rem;
    li {
        padding: 0.2rem 0;
        a {
            color: steelblue;
            font-size: 1.1rem;
            // transition: 0.25s;
        }
        &:hover {
            a {
                color: orangered;
            }
        }
    }
}
.modal-card-title {
    font-size: 1.2rem;
    margin: 0;
}
.fleet-logo {
    width: 90%;
    max-width: 400px;
    margin: 0 auto;
}
.buttons {
    &.right {
        display: flex;
        justify-content: flex-end;
        padding: 0.5rem 0;
    }
}
table {
    &.table {
        tr {
            td {
                &.is-last {
                    border-bottom: none;
                }
            }
        }
    }
}

@media screen and (max-width: 599px) {
    table {
        &.table {
            tr {
                display: block;
                width: 100%;
                margin-bottom: 1rem;
                border: 1px solid #e4e4e4;
                th,
                td {
                    width: 100% !important;
                    display: block;
                }
            }
        }
    }
    .container {
        padding: 1rem 20px 1rem 15px !important;
    }
}
.log-timestamp {
    font-size: 0.85rem;
    color: #666;
}
.log-user {
    font-weight: bold;
    font-size: 0.9rem;
    margin-top: 4px;
}
</style>
